import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'

import { useStyles } from './ItemOffers_style'
import css from './itemoffers.scss'
import { Typography, Grid, Hidden } from '@material-ui/core'

import RouteMap from 'assets/RouteMap'
import { UserContext } from 'contexts/UserContext'
import Button from 'components/Button/Button'
import Switch from 'shared/components/Switch/Switch.jsx'

const ItemOffers = (props) => {
    const { type, setCheckMap, isCheckMap, offerCount, totalCount, selectedLocationTag } = props
    const classes = useStyles()
    const userContext = useContext(UserContext)
    const employerSignupUrl = userContext?.user
        ? RouteMap.Page('users/company_profiles/edit/')
        : RouteMap.Page('employers')

    const handleNewEmployerSignup = () => {
        window.location.href = employerSignupUrl
    }

    const handleEvent = () => {
        var map = document.querySelector('.item-index-map')
        if (map !== null) {
            map.classList.toggle('openedMap')
        }
        var leaderboards = document.querySelectorAll('.LeaderBoard')
        leaderboards.forEach(function (x) {
            x.classList.toggle('closedAdd')
        })
        setCheckMap(!isCheckMap)
    }

    const constructSubTitle = () => {
        return `${getPageSubTitle()}.${getPluralizationSubTitle()}`
    }

    const getPageSubTitle = () => {
        if (!selectedLocationTag) {
            if (type === 'company') {
                return 'item_offers.company.page_sub_title_alt'
            } else {
                return `item_offers.${type}${totalCount ? '.with_total_count' : ''}.page_sub_title`
            }
        } else {
            switch (selectedLocationTag.type) {
            case 'location':
                return `item_offers.${type}.page_sub_title_location`
            case 'studyDomain':
                return `item_offers.${type}.page_sub_title_study_domain`
            case 'quickFilter':
                return `item_offers.title.${type}.quick_filter.${selectedLocationTag.value}`
            default:
                return `item_offers.${type}${totalCount ? '.with_total_count' : ''}.page_sub_title`
            }
        }
    }

    const getFilterName = () => {
        if (!selectedLocationTag) return ''

        if (selectedLocationTag.type === 'location') {
            return selectedLocationTag.name
        } else {
            return selectedLocationTag.name.toLowerCase()
        }
    }

    const getPluralizationSubTitle = () => {
        return offerCount === 0 ? 'zero' : offerCount === 1 ? 'one' : 'other'
    }

    return (
        <Grid container className={classes.itemOffersMainContainer}>
            <Grid item xs={12} sm={6} className={classes.itemOffersTextBox}>
                <FormattedMessage id={constructSubTitle()} values={{ offer_count: offerCount, total_count: totalCount, filter: getFilterName() }} >
                    {text =>
                        <Typography variant='h1' className={classes.pageSubTitle} dangerouslySetInnerHTML={{ __html: text }} />
                    }
                </FormattedMessage>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.buttonContainer}>
                {type === 'company' && <Hidden smDown>
                    <div className="rightPart">
                        <Button
                            size='small'
                            variant='cta-primary'
                            onClick={handleNewEmployerSignup}
                        >
                            <FormattedMessage id="item_offers.company.hiring_cta" />
                        </Button>
                    </div>
                </Hidden>}
                {type === 'kot' && <Hidden smDown>
                    <div className="rightPart">
                        <Typography
                            variant='h1'
                            component='span'
                            className='switchTitle'
                        >
                            <FormattedMessage id="item_offers.afficher_title" />
                        </Typography>
                        <Switch checked={!isCheckMap} onChange={handleEvent} />

                    </div>
                </Hidden>}
            </Grid>
        </Grid>
    )
}

export default ItemOffers
